export default __webpack_public_path__ + "static/media/Shop-11.253efa08.webp";